/**
 * Key into the {@link DealerSearchContext} where the current dealer
 * search value is stored.
 * @type {string}
 */
export const DEALER_SEARCH_VALUE = 'dealerSearchValue';

/**
 * The URL query-string parameter holding the current search input.
 * @type {string}
 */
export const DEALER_QUERY_STRING_PARAM = 'q';



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerSearch/constants.js